// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2244":"92ee5aa6","6205":"61b532d8","8122":"63f873ce","8632":"669cd83b"}[chunkId] + ".chunk.css";
};